export class NumberUtil {

    public static roundToStep(value: number, step: number, up: boolean): number {
        const roundUp = value > 0 ? up : !up;
        const precision = this.decimalPlaces(step);
        const pow = Math.pow(10, precision);
        // Simple rounding before we do anything else, to make sure we didn't get Javascripted too hard
        const initial = this.round(value, precision);
        const adjust = initial < 0 ? -1 : 1;
        const pVal = Math.round(Math.abs(initial) * pow);
        const pStep = step * pow;
        const remainder = pVal % pStep;

        if (remainder === 0) {
            return initial;
        } else if (roundUp) {
            const result = (pVal + (pStep - remainder)) / pow;
            return result * adjust;
        } else {
            const result = (pVal - remainder) / pow;
            return result * adjust;
        }
    }

    public static decimalPlaces(number: number) {
        const split = number.toString().split(".");
        return (split[1] || []).length;
    }

    public static round(value: number, precision: number): number {
        return +value.toFixed(precision);
    }

    public static isPowerOf(value: number, step: number): boolean {
        const precision = this.decimalPlaces(step);
        const pow = Math.pow(10, Math.max(1, precision));
        const pVal = NumberUtil.round(value * pow, precision);
        const pStep = NumberUtil.round(step * pow, precision);
        const remainder = Math.abs(pVal) % pStep;
        return remainder === 0;
    }

    public static tickUpToClosest(value: number, step: number): number {
        const isValid = NumberUtil.isPowerOf(value, step);
        if (isValid) {
            const newVal = value + step;
            return NumberUtil.roundToStep(newVal, step, true);
        } else {
            const difference = this.remainder(value, step);
            const newVal = value + difference;
            return NumberUtil.roundToStep(newVal, step, true);
        }
    }

    private static remainder(value: number, divisor: number): number {
        const multiple = value / divisor;
        const total = multiple * divisor;
        return value - total;
    }

    public static tickDownToClosest(value: number, step: number): number {
        const isValid = NumberUtil.isPowerOf(value, step);
        if (isValid) {
            const newVal = value - step;
            return NumberUtil.roundToStep(newVal, step, false);
        } else {
            const difference = this.remainder(value, step);
            const newVal = value - difference;
            return NumberUtil.roundToStep(newVal, step, false);
        }
    }

    public static gcd(numbers: Array<number>): number;
    public static gcd(a: number, b: number): number;

    public static gcd(a: number | Array<number>, b: number = 1): number {
        if (Array.isArray(a)) {
            return a.reduce((acc, next) => NumberUtil.gcd(acc, next));
        } else {
            a = Math.abs(a);
            b = Math.abs(b);
            while (b > 0) {
                const temp = b;
                b = a % (b);
                a = temp;
            }
            return a;
        }
    }

    public static isValidNumber(value?: number | null): value is number {
        return value != null && !isNaN(Number(value));
    }
}
